<template>
<div>
    <!-- 图文列表 -->
    <div class="cardMain" v-if="cardType != 'download' && cardType != 'magazine'">
      <div class="tabsPart">
          <div v-for="(ttitem, ttindex) in dataList" class="tabsItem" :class="currentIndex == ttindex ? 'active' : ''" :key="ttindex" @click="toList(ttitem)" @mouseover="chooseTab(ttindex)">{{ttitem.title}}</div>
      </div>
      <div
        v-for="(item, index) in dataList"
        :key="index" 
        v-if="currentIndex == index"
      >
        <div v-for="(tItem, tIndex) in item.list" :key="tIndex" class="listcss" style="margin: 6px 0 4px;" v-if="limit != 5" @click="judgmentTurn(tItem)">
          <div class="listcss">
            <div class="square"></div>
            <div class="listcssTitle">{{ tItem.title }}</div>
          </div>
          <div class="listcssDate">{{ tItem.createTime.slice(0,10) }}</div>
        </div>
        <div class="imgLine" v-if="limit == 5"  @click="judgmentTurn(item.list[0])">
            <div class="imgPart">
                <img :src="item.list[0].url" style="width:100%;height:100%"/>
            </div>
            <div class="textPart">
                <div class="title">{{item.list[0].title}}</div>
                <div class="content" id="pic">{{item.list[0].introduce}}</div>
            </div>
        </div>
        <div v-for="(tlItem, tlIndex) in item.list" :key="tlIndex" class="listcss" style="margin: 6px 0 4px;" v-if="limit == 5 && tlIndex != 0" @click="judgmentTurn(tlItem)">
          <div class="listcss">
            <div class="square"></div>
            <div class="listcssTitle">{{ tlItem.title }}</div>
          </div>
          <div class="listcssDate">{{ tlItem.createTime.slice(0,10) }}</div>
        </div>
    </div>
  </div>
  <!-- 滚动列表 -->
  <div class="cardMain" v-if="cardType == 'download' && dataList[1]" style="width: 700px;">
      <div class="tabsPart">
          <div v-for="(ttItem, ttIndex) in dataList" class="tabsItem" :class="currentIndex == ttIndex ? 'active' : ''" :key="ttIndex" @mouseover="chooseTab(ttIndex)">{{ttItem.title}}</div>
      </div>

      <div style="height: 249px;overflow: hidden;" v-if="currentIndex == 0">
        <div  class="unitList">
          <div class="unitItem" v-for="(uItem1, uIndex1) in dataList[0].list" :key="uIndex1+10" @click="toList(dataList[0])">
            <div class="unitSquare"></div>
            <div class="unitTitle"  style="width: 100%;line-height:29px;height:29px;">{{ uItem1 }}</div>
          </div>
        </div>
      </div>
      <div>

      </div>
        <div v-for="(tdItem, tdIndex) in dataList[1].list" :key="tdIndex" class="listcss" v-if="currentIndex == 1" style="margin: 6px 0 4px;">
          <div class="listcss" >
            <div class="square"></div>
            <div class="listcssTitle"  style="width: 100%;line-height:29px;height:29px;" @click="judgmentTurn(tdItem)">{{ tdItem.title }}</div>
          </div>
        </div>
  </div>
  <!-- 杂志列表 -->
  <div class="cardMain magazine" v-if="cardType == 'magazine'" >
    <div class="header">
      <div class="leftPart">
        <img src="@/assets/keben1.png" alt="" style="width:27px;height:27px;"/>
        <div class="text">电子杂志</div>
      </div>
      <div class="rightPart" @click="toList(dataList[0])">更多+</div>
    </div>
    <div class="titleLine"></div>
    <div class="magazineList" v-if="dataList[0]">
        <div v-for="(item,index) in dataList[0].list" class="magazineItem" @click="judgmentTurn(item)">
          <img class="itemImg" :src="item.imageUrl"/>
            <div class="itemTitle" :title="item.title">{{item.title}}</div>
        </div>
    </div>
  </div>
</div>
  
</template>

<script>
  import pdf from "vue-pdf";
export default {
  name: "Footer",
  components:{
    pdf
  },
  props: {
    limit: Number,
    cardType: String,
    Data: Array,
  },
  methods: {
    handleClick() {
      console.log("123");
    },
    chooseTab(index){
        this.currentIndex = index
    },
    toList(item){
      this.$router.push(`/Content?type=${item.title}&typeId=${item.typeId}`)
      
    },
    needHide(){
      //获取文本的行高，并获取文本的高度，假设我们规定的行数是五行，那么对超过行数的部分进行限制高度，并加上省略号
      var pic = document.getElementById("pic")
      if(pic){
        if(pic.clientHeight>57){
          pic.classList.add("p-after")
          pic.style.height = '57px'
        } else {
          pic.classList.remove("p-after")
          pic.style.height = 'auto'
        }
      }
      
    },
    toDetail(item){
      var routeData =  this.$router.resolve({
        path: `/Content`,
        query: {
          type:this.dataList[this.currentIndex].title,
          typeId:this.dataList[this.currentIndex].typeId,
          articleId: item.id
        },
      });
      window.open(routeData.href, '_blank');
    },
    downloadView(item){
      window.open(item.url)
    },
    judgmentTurn(item){
      if(item.imageUrl){
        this.downloadView(item)
      } else {
        this.toDetail(item)
      }
    }
  },
  mounted() {
    var data = JSON.parse(JSON.stringify(this.Data));
    this.dataList = data;

    
    setTimeout(() => {
      this.needHide()
    }, 100);
   
  },
  created(){
    
  },
  data() {
    return {
      currentIndex: 0,
      dataList: []
    };
  },
};
</script>

<style>
.cardMain {
  width: 550px;
  padding: 15px 20px 25px;
  background: #fff;
}
.cardMain .tabsPart{
    display: flex;
    width: 100%;
    border-bottom: 1px solid #dcdcdc;
}
.cardMain .tabsPart .tabsItem{
    width: 130px;
    cursor: pointer;
    font-size: 18px;
    text-align: center;
    border-bottom: 2px solid #fff;
    line-height: 44px;
}
.cardMain .tabsPart .active{
    font-weight: bold;
    color: #3e69b9;
    border-bottom: 2px solid #3e69b9;
}
.cardMain .el-tabs__header {
  margin: 0 0 5px;
}
.cardMain .el-tabs__nav .el-tabs__item {
  font-size: 16px;
  width: 131px;
  height: 45px;
  line-height: 45px;
  padding: 0 !important;
  text-align: center;
}
.cardMain .el-tabs__nav .el-tabs__item.is-active {
  font-weight: bold;
  font-size: 18px;
  color: #3e69b9;
}
.cardMain .el-tabs__nav .el-tabs__active-bar {
  background: #3e69b9;
  height: 3px;
}
.cardMain .listcss {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cardMain .square {
  height: 3px;
  width: 3px;
  margin: 8px;
  background: #000;
}
.cardMain .listcssTitle {
  height: 25px;
  line-height: 25px;
  width: 440px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 16px;
}
.cardMain .listcssTitle:hover {
  text-decoration-line: underline;
  cursor: pointer;
}
.cardMain .listcssDate {
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #999;
}
.cardMain .imgLine {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cardMain .imgLine .imgPart {
  width: 180px;
  height: 120px;
  background: skyblue;
  overflow: hidden;
  margin: 15px 0 10px;
}
@keyframes mymove{
    0%{
    transform: scale(1);  /*开始为原始大小*/
    }
    100%{
        transform: scale(1.3); /*放大1.1倍*/
    }
}
.cardMain .imgLine .imgPart img:hover {
  animation-name: mymove;    
      animation-direction: alternate;  
      animation-timing-function: linear;   
      animation-duration: 0.5s;
      animation-fill-mode : forwards ;
      -webkit-animation-fill-mode : forwards ;
}
.cardMain .imgLine .textPart {
  width: 357px;
}

.cardMain .imgLine .textPart .content {
  font-size: 14px;
  line-height: 19px;
  max-height: 57px;
  text-indent: 2em;
  overflow: hidden;
}
.p-after:after{
    content: "..."; 
    position: absolute; 
    bottom: 0; 
    right: 0; 
    padding-left: 40px;
    background: -webkit-linear-gradient(left, transparent, #fff 55%);
    background: -moz-linear-gradient(left, transparent, #fff 55%);
    background: -o-linear-gradient(left, transparent, #fff 55%);
    background: linear-gradient(to right, transparent, #fff 55%);
}
.cardMain .imgLine .textPart .title {
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  line-height: 30px;
  font-size: 19px;
}
.cardMain .imgLine .textPart .title:hover {
  cursor: pointer;
  text-decoration:underline;
}

.magazine {
  width: 400px;
}

.magazine .header {
  display: flex;
  align-items: center;
  margin: 6px 0 12px;
  justify-content: space-between;
}
.magazine .titleLine {
  width: 100%;
  height: 2px;
  
  background: #e4e7ed;
}
.magazine .header .rightPart {
    cursor: pointer;
  width: 60px;
  font-size: 15px;
  color: #999;
  text-align: right;
}
.magazine .header .leftPart {
  display: flex;
  align-items: center;
  width: 180px;
}
.magazine .header .leftPart .text {
  font-size: 18px;
  margin-left: 10px;
}
.magazine .magazineList {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.magazine .magazineList .magazineItem {
  text-align: center;
  cursor: pointer;
  margin: 13px 15px 1px;
}
.magazine .magazineList .magazineItem .itemImg {
  width: 150px;
  height: 210px;
}
.magazine .magazineList .magazineItem .itemTitle {
  font-size: 16px;
  color: #551a8b;
  overflow: hidden;
  width: 150px;
  text-overflow:ellipsis;
  white-space: nowrap;
}

@keyframes rowup {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(0, -4898px, 0);
    transform: translate3d(0, -4898px, 0);
    display: none;
  }
}
.cardMain .unitList {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-around;
  -webkit-animation: 400s rowup linear infinite normal;
  animation: 400s rowup linear infinite normal;
  flex-wrap: wrap;
}
.cardMain .unitList .unitItem {
  width: 320px;
  height: 40px;
  line-height: 40px;
  margin: 11px 0;
  background: #f8f8f8;
  display: flex;
  align-items: center;
}
.cardMain .unitList .unitItem .unitSquare {
  width: 5px;
  height: 5px;
  margin: 0 20px;
  border: 3px solid #285cac;
}
.cardMain .unitList .unitItem .unitTitle {
  color: #555555;
  font-weight: bold;
  font-size: 16px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.cardMain .unitList .unitItem .unitTitle:hover {
  text-decoration-line: underline;
  cursor: pointer;
}
</style>
